module.exports = "/_next/static/images/e209fb951409a5f8518f568708b26912-david-mobile.jpg.webp";